import React, { PropTypes } from "react";
import { NavItem } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import mfaLogo from "../../../assets/images/mfa_lock.png";

const MFAPreferenceButton = (props) => {
  return (
    <NavItem eventKey="3" onClick={props.onClickHandler}>
      <span className="icon">
        <img src={mfaLogo} width="16" />
      </span>
      <FormattedMessage id="mfaPreferenceForm.mfaPreference" />
    </NavItem>
  );
};

MFAPreferenceButton.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
};

export default MFAPreferenceButton;



// WEBPACK FOOTER //
// ./src/components/common/MFAPreference/MFAPreferenceButton.js